const AttractLoop = {
	isVisible: false,
};

export default {
	AttractLoop,
};
